import {gql} from '@apollo/client';

export const GET_REDEEM_SERVICE_HISTORY_BY_CLUB_ID= gql`
    query getRedeemServiceHistoryByClubId($clubId: String, $includePhoneNumber: Boolean = false, $limit: Int, $offset: Int) {
      getRedeemServiceHistoryByClubId(clubId: $clubId, limit: $limit, offset: $offset) {
        id
    clubId
    clubName
    clubCity
    clubState
    clubCountry
    userName
    phoneNumber @include(if: $includePhoneNumber)
    redeemServiceDetails {
      alcoholName
      count
      shelf
    }
    redeemServiceRequestTime
    redeemServiceConfirmTime
    redeemServiceStatus
  }
}
`;

export const GET_ALL_REDEEM_SERVICE_HISTORY= gql`
    query getAllRedeemServiceHistory($limit: Int, $offset: Int) {
      getAllRedeemServiceHistory(limit: $limit, offset: $offset) {
        id
    clubId
    clubName
    clubCity
    clubState
    clubCountry
    userName
    phoneNumber
    redeemServiceDetails {
      alcoholName
      count
      shelf
    }
    redeemServiceRequestTime
    redeemServiceConfirmTime
    redeemServiceStatus
  }
}
`;

export const REDEEM_SERVICE_HISTORY_UPDATED = gql`
  subscription redeemServiceHistoryUpdated($clubId: String!, $includePhoneNumber: Boolean = false) {
    redeemServiceHistoryUpdated(clubId: $clubId) {
      id
      clubId
      clubName
      clubCity
      clubState
      clubCountry
      userName
      phoneNumber @include(if: $includePhoneNumber)
      redeemServiceDetails {
        alcoholName
        count
        shelf
      }
      redeemServiceRequestTime
      redeemServiceConfirmTime
      redeemServiceStatus
    }
  }
`;

export const ALL_REDEEM_SERVICE_HISTORY_UPDATED = gql`
  subscription allRedeemServiceHistoryUpdated {
    allRedeemServiceHistoryUpdated {
      id
      clubId
      clubName
      clubCity
      clubState
      clubCountry
      userName
      phoneNumber
      redeemServiceDetails {
        alcoholName
        count
        shelf
      }
      redeemServiceRequestTime
      redeemServiceConfirmTime
      redeemServiceStatus
    }
  }
`;
